<template>
  <div class="my_line_height_layer jz_text_edit_panel">
    <div :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" v-if="title !== ''" :style="{
      width: titleWidth + 'px'
      }"></span>
      <div class="line_height_setting_wrap">
        <div class="line_height_setting jz-select jz-select-single"
             ref="line_height_dialog"
             :class="lineHeightDialogIsShow ? 'jz-select-visible': ''"
             @click="lineHeightDialogIsShow=!lineHeightDialogIsShow">
          <div class="jz-select-selection">
            <span class="jz-select-selected-value">{{line_height == 10 ? $t('view_back_top_edit_103'): line_height}}</span>
            <i class="jz-select-arrow" :class="lineHeightDialogIsShow ? 'jz-select-trigger-arrow': ''"></i>
          </div>
          <div class="jz-select-dropdown" v-if="lineHeightDialogIsShow">
            <ul class="jz-select-dropdown-list">
              <div class="jz_scrollbar" style="max-height: 155px;">
                <div class="jz_scrollbar__wrap" style="margin-right: 1px;height: calc(100% + 17px); max-height: 172px;">
                  <div class="jz_scrollbar__resize">
                    <div class="jz_scrollbar__view">
                      <li class="jz-select-item"
                          v-for="(item,index) in options" :key="index"
                          @click="selectLineHeight(item.value)"
                          v-text="item.label"></li>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
        <span class="setting_list_select_icon setting_list_icon setting_icon_line_height"></span>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

  export default {
    name:'my_line_height_index',
    props:{
      titleWidth: {
        type:String,
        default: '40'
      },
      title: { // 组件的标题
        type:String,
        default: ''
      },
      type: { // 组件的类型  one_level 一级组件 two_level 二级组件
        type:String,
        default: 'two_level'
      },
      lineHeight: {
      },
      options:{ // 数组
        type:Array,
        default:function () {
          return []
        }
      },
    },
    data(){
      return {
        line_height:this.lineHeight,
        lineHeightDialogIsShow: false
      }
    },
    mounted() {
      //如果有报错可以写
      this.$nextTick(() => {
        document.addEventListener('click', e => {
          const dom = this.$refs.line_height_dialog;
          if (dom && !dom.contains(e.target)) {
            this.lineHeightDialogIsShow = false;
          }
        });
      });
    },
    beforeDestroy() {
      document.removeEventListener('click', e => {
        this.lineHeightDialogIsShow = false;
      });
    },
    watch:{
      line_height(val){
        this.$emit('update:lineHeight',val);//双向数据绑定
      },
      'lineHeight'(val){
        this.line_height = val
      }
    },
    computed:{
    },
    methods:{
      selectLineHeight(val) {
        this.line_height = val
        this.lineHeightDialogIsShow = false;
      }
    }
  }
</script>

<style scoped type="text/css" lang="scss">
  .jz_scrollbar__view {
    width: 62px;
  }

</style>



// WEBPACK FOOTER //
// src/components/my_line_height/index.vue